export enum Scan3dListFilterOption {
  ShowAll = 'ShowAll',
  ShowSelected = 'ShowSelected',
}
